import React, {useEffect, useRef, useState} from "react";
import { Link } from "react-router-dom";
//https://react-slideshow.herokuapp.com/api
import { Slide } from 'react-slideshow-image';
import Section from 'components/Section';
import Button from "components/Button";
import Features from "components/Features";
import Img from "components/Img";
import ApartmentListings from "components/Apartment/ApartmentListings";
import Divider from "components/Divider";
import Faq from "components/Faq";
import { Gallery, Item } from 'react-photoswipe-gallery'

import 'assets/css/Index.min.css';
import 'react-slideshow-image/dist/styles.css';

import apartment_image_1 from 'assets/images/csango10-elado-lakasok.webp';
import apartment_image_2 from 'assets/images/csango10-ujepitesu-lakasok.webp';
import apartment_image_3 from 'assets/images/csango10-13kerulet-elado-lakasok.webp';

import apartment_image_4 from 'assets/images/csango10-13kerulet-elado-lakasok-1.webp';
import apartment_image_5 from 'assets/images/csango10-13kerulet-elado-lakasok-2.webp';
import apartment_image_6 from 'assets/images/csango10-13kerulet-elado-lakasok-3.webp';
import apartment_image_7 from 'assets/images/csango10-13kerulet-elado-lakasok-4.webp';

import processs_image_1 from 'assets/images/folyamat/f1.jpg';
import processs_image_2 from 'assets/images/folyamat/f2.jpg';
import processs_image_3 from 'assets/images/folyamat/f3.jpg';
import processs_image_4 from 'assets/images/folyamat/f4.jpg';
import processs_image_5 from 'assets/images/folyamat/f5.jpg';
import processs_image_6 from 'assets/images/folyamat/f6.jpg';

import req from 'functions/req';
import modifyState from "functions/modifyState";
import FeedbackModal from "components/FeedbackModal";

import validator from "functions/validator";

import { useLocation, useHistory   } from "react-router-dom";
import routes from "configs/routes";
import clg from "functions/log";
import settings from "configs/settings";

const Index = ({footerRef, forwardRef, newsletterRef}) => {


    const location = useLocation();
    const history = useHistory();

    const [feedback, setFeedback] = useState({
        open: false,
        success: false,
        title: null,
        text: null,
      });

      const [emailSubscriptionLoading, setEmailSubscriptionLoading] = useState(false);

    const emailSubscriptionInputRef = useRef(null);
    const [emailSubscriptonInputValid, setEmailSubscriptionInputValid] = useState(true);

    const mainSliderImages = [
        {
            url: apartment_image_7,
        },
        {
          url: apartment_image_1,
        },
        {
            url: apartment_image_6,
          },
        {
          url: apartment_image_2,
        },
        {
          url: apartment_image_3,
        },
        {
          url: apartment_image_4,
        },
        {
          url: apartment_image_5,
        },
        
    ];

    clg("INDEX PROPS: ", footerRef)


    useEffect(()=>{
        console.log("location: ", location);
        const hash = location?.hash || null;


        switch (hash) {
            case routes.introduction.replace("/", ""):
                if( forwardRef?.current ) {
                    console.log("SCROLL TO: ", forwardRef)
                    forwardRef.current.scrollIntoView();
                }
                break;
        }

    },[location])

    return (
        <>
        <div>
            <div className="index-main-image-slider">
                <Slide className="image-slider" arrows={false} canSwipe={false} pauseOnHover={false} duration={4000} transitionDuration={1000} >
                    {mainSliderImages.map((slideImage, index)=> (
                        <div className="each-slide overlay" key={index}>
                            <div style={{'backgroundImage': `url(${slideImage.url})`}}>
                                <span>{slideImage.caption}</span>
                            </div>
                        </div>
                    ))} 
                </Slide> 
            </div>
        </div>

        <div className="index-main-container">
            <div className="row justify-content-center align-items-center">
                {/* <div className="col-12">
                    <div className="sale-started-badge">Az értékesítés elkezdődött!</div>
                </div> */}

                <div className={"nav-alert-static w-full mb-2"} style={{width : "100%", maxWidth : "576px"}}>
                    Azonnal költözhető lakások
                </div> 

                <div className="col-12 text-center text">
                    Otthon,<br/> kompromisszumok nélkül
                </div>

                {/*<div className="col-12">
                    <Link to={routes.blogSingle.replace(":slug", "nyar-vegi-gepkocsi-beallo-es-redony-akcio-1")  } className={"nav-alert-static mt-3 mb-3"}>Nyár végi gépkocsi beálló és redőny akció!<br/> 1.700.000 Forint értékű kedvezmény!</Link>
                </div>*/}
                
                <div className="col-12 mb-4 d-flex justify-content-center mt-3 cta">
                    <Button className="btn-secondary large" text="Lakások megtekintése" icon="fas fa-building" to={ routes.apartments } />
                </div>
            </div>
        </div>

        <Features
            featureItemTitleTagType="h3"
            type="for-decoration"
            rowClass="justify-content-center"
            data={
            [
                { title : "Új építésű lakások", iconClass : "large c-icon-newly-built-house" },
                { title : "Biztos háttér", iconClass : "large c-icon-verified-background" },
                //{ title : "Eladó lakások", iconClass : "large c-icon-house-for-sale" },
                { title : "Személyes ügyintézés", iconClass : "large c-icon-personal-administration" },
            ]
        }/>

        <div className="current-progress">
            {/*<Button to="/hirek/emelt-szerkezetkesz-a-csango-10-epulete" className="btn-secondary large" text="Az társasház jelenlegi állapotának megtekintése"/>*/}
            
            <Button className="btn-secondary large pointer-events-none" text="Személyes találkozó előtt időpontegyeztetés szükséges!" /> 
        
            {/* <div style={{background : "#257873", padding : 16, borderRadius : 8, maxWidth : 576}}>
                <p style={{color : "#ffffff", textAlign : "center", fontSize : 18, fontWeight : 700, marginBottom : 10}}>Kedves Ügyfelünk!</p>
                <p style={{color : "#ffffff", textAlign : "center"}}>2024. december 17. és 2025. január 6. között szabadságon vagyunk. Boldog, békés karácsonyt, valamint sikerekben gazdag új évet kívánunk!</p>
            </div> */}

            {/* Azért van pointer-events-none a gombon, mert olyan elem kellett ami csak itt van, gomb kinézetű, de nem kattintható */}
        </div>

        <Section additionalClasses="pb-0 pt-0" title="AZONNAL KÖLTÖZHETŐ ÚJ ÉPÍTÉSŰ LAKÁSOK" description="Válassz eladó lakásaink közül igényeidnek megfelelően! Legyen az akár stúdiólakás, kétszobás kuckó, vagy családias hangulatú, nagy terekkel kialakított komfortos otthon.">
            <ApartmentListings enableViewSelect={ false } endpoint="featuredProperties" disablePagination={true} disableFilters={true}/>
            <div className="row">
                <div className="col-12 d-flex justify-content-center mt-5">
                    <Button className="btn-secondary large mw-250" text="További lakások" icon="fas fa-building" to={ routes.apartments } />
                </div>
            </div>
        </Section>

        <Section
            additionalClasses="pb-0"
            title="A társasház azonnal költözhető"
            description="Rendelkezünk jogerős használatbavételi engedéllyel, a társasház sikeresen bejegyzésre került és a lakásaink azonnal költözhetőek!"
        >
            <div className="row index-process-gallery-row">
                <Gallery
                    closeButtonCaption="Bezárás"
                    shareButton={false}
                    fullscreenButton={false}
                    nextButtonCaption="Következő"
                    prevButtonCaption="Előző"
                >
                    {
                        [{src : processs_image_1}, {src : processs_image_2}, {src : processs_image_3, }, {src : processs_image_4} ,{src : processs_image_5}, {src : processs_image_6}].map((curr,index)=>(
                        <div className="col-lg-4 col-md-6 col-12 gallery-item" key={`gallery-item-${index}`}>
                            <Item
                                original={curr.src}
                                thumbnail={curr.src}
                                width="1024"
                                height="768"
                                //onChange={(e) => clg("asdsd",e)}
                                >
                                {({ ref, open }) => (
                                    <div className="d-contents h-100 w-100" ref={ref}>
                                        <Img className="index-process-image" onClick={open} src={curr.src} skeletonprops={{ height: 300 }}/>
                                    </div>
                                )}
                            </Item>
                        </div>
                        ))
                        
                    }
                </Gallery>


                <div className="col-12 d-flex justify-content-center">
                    <Button className="btn-secondary max-width-100 mt-3" text="Galéria megtekintése" to={routes.gallery} />
                </div>
            </div>
        </Section>

        <Divider additionalClasses="index-contact-divider mt-section with-brown-bg">
            <div className="row" ref={newsletterRef}>
                <div className="col-12">
                    <h2 className="text-white text-center">Kövesse nyomon az eseményeket!</h2>
                    <p className="lead narrow-w mb-4 text-center text-white">Iratkozzon fel hírlevelünkre, hogy ne maradjon le híreinkről!</p>
                </div>
                <div className="col-12 text-center form-search newsletter-container d-flex justify-content-center gap-3 flex-wrap">
                    <input type="text" className="external-form-control px-4 w-100 max-w-600" placeholder="Adja meg e-mail címét" id="newsletter-email" ref={emailSubscriptionInputRef}/>
                    <Button className="btn btn-secondary mw-100" id="send-news-subscription" text="Feliratkozom a hírlevélre" loader={emailSubscriptionLoading ? 1 : 0} onClick={async ()=>{

                        const value = emailSubscriptionInputRef.current.value;
                        const isValid = validator.validateEmail(value);

                        setEmailSubscriptionInputValid(isValid);

                        if(isValid) {
                            //req...

                            setEmailSubscriptionLoading(true);
                            //await new Promise(r => setTimeout(r,1000));

                            req({url : "save-contact.php", method : "POST", data : {email: value}}).then(res => {
                                if( res && res?.success ) {
                                    setEmailSubscriptionLoading(false);
                                    modifyState(feedback, setFeedback, {
                                        open: true,
                                        success: true,
                                        text: "Az üzenet elküldése sikeres volt!",
                                    });
                                    emailSubscriptionInputRef.current.value = "";
                                    setEmailSubscriptionInputValid(true);
                                } else throw res;
                            }).catch(err=>{
                                setEmailSubscriptionLoading(false);
                                modifyState(feedback, setFeedback, {
                                    open: true,
                                    success: false,
                                    text: "Hiba történt az üzenet elküldése során!",
                                });
                            })

                            
                        }

                    }}/>
                </div>


                <div className="col-12 d-flex justify-content-center mt-3">
                {!emailSubscriptonInputValid && (
                    <span className="text-white bg-error px-1 rounded-sm">Érvényes email címet adjon meg!</span>
                )}
                </div>
            </div>
        </Divider>

        <Section additionalClasses="" forwardRef={forwardRef}>
            <div className="row justify-content-between">
                
                <div className="col-lg-8 col-12 dots dots-top-right shifted-text-part-img-container order-md-2 order-lg-1" id={routes.introduction.replace("/#","")}>
                    <Img src={ apartment_image_3 } className="img-fluid" skeletonprops={ { height: 295 } }/>
                </div>

                <div className="col-lg-4 col-12 text-part shift-content-left order-md-1 order-lg-2">
                    <div className="text-part-content">
                        <div className="title">Bemutatkozás</div>
                        <div className="capital">Budapest szívében, a <b>13. kerületben</b> dolgozunk legújabb projektünkön, a “Csángó 10” társasházon. Ha otthont, befektetést, vagy saját irodát keresel csendes környezetben, kiváló közlekedéssel, nálunk biztosan megtalálod a megfelelőt.</div>
                        <div className="text">Cégcsoportunk több mint <b>10 éve</b> foglalkozik lakóparkok és lakások építésével, értékesítésével és kiadásával.</div>
                        <div className="text">Ismertebb fejlesztéseink közé tartozik:
                            <ul>
                                <li>a Hattyúház (I. kerület, Hattyú utca)</li>
                                <li>a McDonald’s Gyáli úti központja</li>
                                <li>a XI. kerület Hauszmann utcában található BHG Irodaház-együttes</li>
                                <li>a Pozsonyi Ház (XIII. kerület, Ipoly utca)</li>
                                <li>Rahó Kert (XI. kerület, Rahó utca)</li>
                                <li>Pannónia Ház (XIII. kerület, Pannónia utca)</li>
                                <li>Kelenliget Ház (XI. kerület, Fehérvári út)</li>
                                <li>vidéki Penny Market áruházak, logisztikai ingatlanok</li>
                            </ul>
                        </div>
                        <div className="text">Magyarországon fontos, ismert piaci szereplők vagyunk. A határidők pontos betartásával, az esetleges akadályok <b>professzionális</b> kezelésével megdolgoztunk a bizalomért.</div>
                        <div className="text">Megbízhatóságunknak, minőségi kivitelezésünknek, <b>stabil hátterünknek</b> köszönhetően számos referenciával rendelkezünk.</div>
                        <div className="text mt-4"><Button className="btn-secondary" to={routes.contact} text="Kapcsolat" onClick={(e) => {
                            e.preventDefault();
                            history.push(routes.contact)
                            }} /* onClick={() => footerRef.current.scrollIntoView()} */ /></div>
                    </div>
                </div>

                {/* <div className="spacer mt-lg-50 col-12"></div> */}

                <div className="col-lg-8 col-12 dots dots-bottom-right shifted-text-part-img-container order-md-4 order-lg-3">
                    <Img src={ apartment_image_7 } className="img-fluid" skeletonprops={ { height: 295 } }/>
                </div>

                <div className="col-lg-4 col-12 text-part shift-content-left order-md-3 order-lg-4">
                    <div className="text-part-content">
                        <div className="title">Lakást építünk...</div>
                        <div className="capital">Milyen egyszerűen hangzik, mégis mindenkinek más jut eszébe a végeredményről. Otthon, első lakás, befektetés, munka, üzlet - bármi is legyen a vásárló célja, nekünk már a tervezésnél gondolni kell rá, hiszen szeretnénk, hogy mindenki megtalálja nálunk a számára tökéletes megoldást.</div>
                        <div className="text">Először a helyszínt választjuk ki. Sétálgatunk a környéken, felmérjük milyen is lenne itt élni. Szívesen élnénk itt családdal? Biztonságos a környék? Milyen a tömegközlekedés? El tudunk jutni gyorsan a belvárosba? Van elég parkolóhely, ha egy hosszú nap után hazaérünk? Elérhetőek a közelben a mindennapokhoz szükséges szolgáltatások? Ez csak néhány kérdés, amit mérlegelünk, mielőtt belevágunk az építésbe.</div>
                        <div className="text">Nem, nem egy jellegtelen sokemeltes házat szeretnénk építeni, hanem egyedit. Olyat, amilyet nem lehet minden sarkon látni a városban. Ahová szívesen érkezel haza, ahol <b>biztonságban</b> lehet a gyermeked, ahol jó a lakóközösség.</div>
                        <div className="text">Ragaszkodunk a <b>precíz</b>, praktikus és az igényeknek legmegfelelőbb tervekhez. Talán apróság, de ki szeretne éjjel belerúgni a konyhapult sarkába, ha ez egy kis módosítással könnyen elkerülhető?</div>
                        <div className="text mt-4"><Button className="btn-secondary" text="Lakásaink" to={ routes.apartments } /></div>
                    </div>
                </div>

            </div>
        </Section>

        <Section
        title="TALÁLD MEG ÁLMAID OTTHONÁT ELADÓ LAKÁSAINK KÖZÖTT!"
        description="Budapest egyik legkedveltebb kerületében, közel a belvároshoz,  mégis csendes, biztonságos környezetben várja új lakóit modern stílusban társasházunk."
        additionalClasses="section-4 pt-0"
        hTagType="h1">

            <div className="row justify-content-between mb-5">
                <div className="col-lg-7 mb-5 mb-lg-0">
                    <div className="img-about dots dots-bottom-left">
                        <Img src={ apartment_image_1 } skeletonprops={ { height: 347 } } className="img-fluid"/>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="d-flex feature-h">
                        <span className="wrap-icon mr-3">
                            <i className="fas fa-building icon"></i>
                        </span>
                        <div className="feature-text">
                            <h3 className="heading">KORSZERŰ LAKÁSOK</h3>
                            <p className="">Építsük együtt a jövőt! A 21. század technológiáival és energiatakarékos megoldásainkkal óvjuk környezetünket. Célunk, hogy közel hozzuk a természetet, így a lakásokból kilátás nyílik a belső parkra. Minden lakáshoz erkély is tartozik.</p>   
                        </div>
                    </div>

                    <div className="d-flex feature-h">
                        <span className="wrap-icon mr-3">
                            <i className="fas fa-star"></i>
                        </span>
                        <div className="feature-text">
                            <h3 className="heading">MINŐSÉG</h3>
                            <p className="">Kiemelten fontos számunkra lakásaink kiváló minősége és a profi munkavégzés, a tervezéstől egészen a kivitelezés lezárásáig.</p>   
                        </div>
                    </div>

                    <div className="d-flex feature-h">
                        <span className="wrap-icon mr-3">
                            <i className="fas fa-hand-holding-usd"></i>
                        </span>
                        <div className="feature-text">
                            <h3 className="heading">BEFEKTETÉS</h3>
                            <p className="">Korszerű lakásaink kiváló lehetőséget nyújtanak akkor is, ha befektetésre vásárolnál ingatlant.</p>   
                        </div>
                    </div>
{/*                     <Button className="btn-secondary mt-3" text="Lakások" to={ routes.apartments } />
 */}
                </div>
            </div>
            <div className="row section-counter mt-5">
                <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                    <div className="counter-wrap mb-5 mb-lg-0">
                        <span className="number"><span className="countup text-primary">95</span></span>
                        <span className="caption ">Lakás</span>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                    <div className="counter-wrap mb-5 mb-lg-0">
                        <span className="number"><span className="countup text-primary">4700</span></span>
                        <span className="caption ">Négyzetméter</span>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                    <div className="counter-wrap mb-5 mb-lg-0">
                        <span className="number"><span className="countup text-primary">5</span></span>
                        <span className="caption ">Emelet</span>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                    <div className="counter-wrap mb-5 mb-lg-0">
                        <span className="number"><span className="countup text-primary">99</span></span>
                        <span className="caption ">Garázs beálló</span>
                    </div>
                </div>
            </div>

        </Section>

        <Divider additionalClasses="index-contact-divider">
            <div className="row">
                <div className="col-12">
                    <h2 className="text-white text-center">Lépj velünk kapcsolatba!</h2>
                </div>
                <a href={`mailto:${settings.contact.email}`} className="col-12 mt-4 email">
                    <i className="fas fa-envelope"></i>{settings.contact.email}
                </a>
                <div className="col-12 mt-4">
                    <Button text="Kapcsolat" to={routes.contact} onClick={(e) => {e.preventDefault();history.push(routes.contact)}} /* onClick={ () => footerRef.current.scrollIntoView() } */ className="btn-primary mt-3 light-semi-transparent large mw-250 m-auto" icon="far fa-comment-dots" />
                </div>
            </div>
        </Divider>

        {/* <Section
        title="Bemutatkozás"
        description="Cégcsoportunk több mint 10 éve foglalkozik lakóparkok és lakások építésével, azok értékesítésével és kiadásával."
        additionalClasses="bg-off-white border-top-gray pb-3">

            <div className="row justify-content-between">
                <div className="col-lg-6 mb-5 mb-lg-0">
                    <div className="img-about dots dots-top-right">
                        <Img src={ apartment_image_2 } className="img-fluid" skeletonprops={ { height: 295 } }/>
                    </div>
                </div>

                <div className="col-lg-6 text-part">

                    <div className="part-title">Lokáció</div>
                    Ön is csendre, nyugodt környezetre vágyik még karnyújtásnyira a nyüzsgő belvárostól? Újonnan épülő társasházunk a 13. kerület szívében helyezkedik el, amely kiváló infrastruktúrájának köszönhetően minden korosztály számára ideális. Teendőit gyorsan, könnyedén és kényelmesen intézheti, hiszen minden rendkívül egyszerűen megközelíthető. Tömegközlekedés szempontjából az M3-as metrómegálló mindössze 5 perces sétával elérhető, a belváros pedig szintén ugyanennyi idő alatt megközelíthető autóval.  
                    
                    <div className="part-title">Sokszínűség</div>
                    13. kerületi társasházunk ideális választás lehet, ha első otthonát szeretné megvásárolni, ha nagyobb újépítésű lakást keres vagy befektetés céljából válogatna eladó lakásaink közül. Újépítésű ingatlanjaink között 30 m2-től egészen 90 m2-es, lakások között válogathat, így biztosan megtalálva az ön számára legmegfelelőbbet. Természetesen választott otthonát egyedi elképzeléseinek megfelelően alakítjuk ki, még a tervezés során. Korszerű és innovatív technológiák, energiatakarékos megoldásokkal pedig óvjuk környezetünket is. 
                    
                    <div className="part-title">Megbízhatóság</div>
                    Fontos számunkra, hogy kiváló minőséget biztosítsunk leendő lakás tulajdonosaink számára, akik eladó lakásaink közül választják ki álomotthonukat. Kiemelkedően stabil anyagi háttérrel rendelkezünk, ennek köszönhetően velünk bátran tervezhet, kitűzött átadásaink kivétel nélkül időben megvalósultak. Cégcsoportunk jelentős portfólióval rendelkezik, többek között az 1. kerületben található Hattyú-ház, a 11. kerületben található Kelenliget lakópark, de a 13. kerület sem ismeretlen számunkra, ugyanis a néhány utcára található Pannónia Ház is cégcsoportunk nevéhez fűződik.  
                    <Button className="btn-secondary mt-3" text="Lakások" to={ routes.apartments } />
                </div>

            </div>

        </Section> */}

        <Faq 
            data={[
                {
                    title : "A társasház jogerős használatbavételi engedéllyel rendelkezik?",
                    description : "Igen.",
                },
                {
                    title : "A társasház sikeresen bejegyzésre került?",
                    description : "Igen.",
                },
                {
                    title : "A lakások azonnal költözhetőek?",
                    description : "Igen.",
                },
                /* {
                    title : "Mikor lesz az átadás?",
                    description : "Lakásaink várhatóan 2024.02.29-én kerülnek átadásra."
                }, */
                /*{
                    title : "Hogyan vásárolhatom meg a Csángó10 társasházban jövendőbeli lakásom?",
                    description : "Habozás nélkül keresd fel értékesítő kollégáinkat, akik készséggel állnak rendelkezésedre és segítenek kiválasztani a megfelelő lakást."
                },*/
                /* {
                    title : "Szerkezetkész állapotban is megvásárolhatom a lakást?",
                    description : "Igen, az építkezés bármely szakaszában lehetőség van a vásárlásra."
                }, */
                /* {
                    //2024.06.06 - Ugyan MZoli "megnézte" és "nem találta", de benne volt, hogy az eladót terhelik az ügyvédi költségek.
                    //Mostantól a vásárlót terhelik ezek a költségek.
                    title : "Az ügyvédi költségek kit terhelnek?",
                    description : "A vevőt."
                }, */
            ]}
        />

<FeedbackModal
        open={feedback.open}
        success={feedback.success}
        title={feedback.title}
        text={feedback.text}
        defaultState={feedback}
        setDefaultState={setFeedback}
      />


        </>
    );
}

export default Index;

